import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

@connect(
    state => ({
        isOnline: state.apa.isOnline
    })
)
export default class NetworkDetection extends Component {
    render() {
        return (
            <Fragment>
                {
                    !this.props.isOnline &&
                    <div className={'bg-warning p-3 network-error'}>
                        Internetverbindung unterbrochen oder der Server antwortet nicht.
                    </div>
                }
                {this.props.children}
            </Fragment>
        )
    }
}

NetworkDetection.propTypes = {
    isOnline: PropTypes.bool,
    children: PropTypes.array
}